export interface StateResult {
  state: string;
}
